module.exports = __webpack_public_path__ + "img/404.001a6b46.png";